import { UserPanelMetaData } from '../../layout-meta-data/user-panel-meta-data';
import { Expose, Type } from '@nts/std/serialization';
import { BaseLayoutDataDto } from './base-layout-data.dto';
import type { PanelUserLayoutDataDtoInterface, UserPanelMetaDataInterface } from '@nts/std/interfaces';

export class PanelUserLayoutDataDto extends BaseLayoutDataDto implements PanelUserLayoutDataDtoInterface {

    constructor() {
        super();
        this.panelMetaData = new UserPanelMetaData();
    }

    @Expose()
    @Type(() => UserPanelMetaData)
    panelMetaData: UserPanelMetaDataInterface;
}
